import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, ArrowRight } from 'lucide-react';
import logo from '../../assets/cvj.png'; // Assuming CVJ logo; update path if needed
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setTimeout(() => setSubscribed(false), 3000);
    setEmail('');
  };

  const linkVariants = {
    hover: { x: 5, color: '#FF007A', transition: { duration: 0.3 } },
  };

  const buttonVariants = {
    hover: { scale: 1.05, backgroundColor: '#FF007A' },
    tap: { scale: 0.95 },
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img alt="CVJ Services Ltd" className="footer-logo" src={logo} />
            <p className="footer-tagline">Driving UK Freight Forward</p>
            <p className="footer-description">
              CVJ Services Ltd - Northampton’s premier freight transport provider since 2025.
            </p>
          </motion.div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Explore</h4>
            <motion.a href="#home" variants={linkVariants} whileHover="hover">
              Home <ArrowRight size={16} />
            </motion.a>
            <motion.a href="#fleet" variants={linkVariants} whileHover="hover">
              Fleet <ArrowRight size={16} />
            </motion.a>
            <motion.a href="#coverage" variants={linkVariants} whileHover="hover">
              Coverage <ArrowRight size={16} />
            </motion.a>
            <motion.a href="#about" variants={linkVariants} whileHover="hover">
              About <ArrowRight size={16} />
            </motion.a>
            <motion.a href="#contact" variants={linkVariants} whileHover="hover">
              Contact <ArrowRight size={16} />
            </motion.a>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Get in Touch</h4>
            <motion.div className="contact-item" whileHover={{ scale: 1.02 }}>
              <Phone size={20} />
              <a href="tel:+447304244779">07304 244779</a>
            </motion.div>
            <motion.div className="contact-item" whileHover={{ scale: 1.02 }}>
              <Mail size={20} />
              <a href="mailto:jinalchaudhary642@gmail.com">jinalchaudhary642@gmail.com</a>
            </motion.div>
            <motion.div className="contact-item" whileHover={{ scale: 1.02 }}>
              <MapPin size={20} />
              <span>12 Waghorn Road, London, E13 9JQ</span>
            </motion.div>
          </div>

          {/* Newsletter */}
          <div className="footer-newsletter">
            <h4 className="footer-heading">Stay Connected</h4>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                className="newsletter-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <motion.button
                type="submit"
                className="newsletter-btn"
                variants={buttonVariants}
                whileHover="hover"
                whileTap="tap"
              >
                Subscribe
              </motion.button>
            </form>
            {subscribed && (
              <motion.p
                className="newsletter-success"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                Subscribed! We’ll keep you posted.
              </motion.p>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <p className="footer-copyright">
            © 2025 CVJ Services Ltd. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;